import axios from 'axios';
import Environments from '../environments/Environment';

var http = null;

class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.BASE_URL2,
            headers: { 'Content-Type': 'application/json' },
        });
    }

    getVehicles(filters) {
        return new Promise((success, error) => {
            http.post('/vehicles/search', filters).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            });
        }).catch(function(err) {
            if (err.response) {
                error(err.response.data);
            } else if (err.request) {
                error(err.request);
            } else {
                error(err.message);
            }
            // console.log(error.config);
        });
    }

    getVehicle(id) {
        return new Promise((success, error) => {
            http.get(`/landing/vehicles/show/${id}`, {
                params: { isLanding: true }
            }).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    getVehiclesRecents() {
        return new Promise((success, error) => {
            http.get('/landing/vehicles/recents', {
                params: { page: 1, limit: 4 }
            }).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    newLead(data) {
        return new Promise((success, error) => {
            http.post('/landing/leads', data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    newInterest(vehicleId, leadId) {

        let data = {
            vehicleId: vehicleId,
            leadId: leadId
        };

        return new Promise((success, error) => {
            http.post('/landing/interest', data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    updateInterest(id, data) {

        return new Promise((success, error) => {
            http.put(`/landing/interest/${id}`, data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/Vehicles.js